<template lang="pug">
	.project-actions-create(v-if="showed && Template.SelectedTemplate")
		.card
			.card-header
				i.fa.fa-edit
				span Create Project
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label(for="prependedInput") Title of new project
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="create()") Create
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import _ 					from 'lodash';

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';

	export default {
		name: "ProjectActionsCreate",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;

			return {
				title: ''
			}
		},
		methods: {
			collectData() {

				this.title = this.getNextSettingsTitle();

			},
			create() {

				Server.sendToSocket({
					CreateNewProject: {
						templateId: Template.SelectedTemplate.id,
						title: this.title
					}
				});

				this.hide();

			},
			getNextSettingsTitle() {

				let title_base = 'New project ';

				let title_number = 1;
				let title = title_base + title_number;

				while (_.find(Project.Projects, o => o.title === title)) {

					title_number++;
					title = title_base + title_number;

				}

				return title;

			}
		}
	}
</script>


<style lang="sass">

	.project-actions-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 220px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

</style>

